import { render, staticRenderFns } from "./RichTextBox.vue?vue&type=template&id=11f1d7cb&scoped=true&"
import script from "./RichTextBox.vue?vue&type=script&lang=js&"
export * from "./RichTextBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f1d7cb",
  null
  
)

export default component.exports